var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("path",props);
}

ArrowLeftInline.defaultProps = {"d":"M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
